(function () {
  var backToTopButton = document.getElementById('back-to-top');
  if (!backToTopButton) return;

  function toggleBackToTopButton() {
    // Only show on non-touch/non-mobile viewports
    if (window.innerWidth <= 768) {
      backToTopButton.style.display = 'none';
      return;
    }
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      backToTopButton.style.display = 'block';
    } else {
      backToTopButton.style.display = 'none';
    }
  }

  window.addEventListener('scroll', toggleBackToTopButton, { passive: true });

  backToTopButton.addEventListener('click', function () {
    // Synchronous DOM mutation so analytics tools (e.g. Clarity) don't flag
    // this as a dead click — window.scrollTo() is invisible to MutationObserver.
    this.setAttribute('aria-busy', 'true');
    scrollToTop(this);
  });

  function scrollToTop(button) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.scrollTo(0, 0);
      button.removeAttribute('aria-busy');
      return;
    }

    var startPosition = window.scrollY;
    var duration = 500;
    var startTime = null;

    function animation(currentTime) {
      if (startTime === null) startTime = currentTime;
      var timeElapsed = currentTime - startTime;
      var progress = Math.min(timeElapsed / duration, 1);
      var ease = 1 - Math.pow(1 - progress, 3);
      window.scrollTo(0, startPosition * (1 - ease));
      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      } else {
        button.removeAttribute('aria-busy');
      }
    }

    requestAnimationFrame(animation);
  }
})();
